// hooks/useIsSameAppointment.ts
import { useAtomValue } from 'jotai';

import { appointmentDataAtom } from '../atoms/appointment';
import { recorderStatusAtom } from '../atoms/recording';

export interface AppointmentData {
  estimatedVisitId?: number | null;
  unifiedId?: string;
}

export const useIsSameAppointment = (
  appointment: AppointmentData | null,
): boolean => {
  const appointmentData = useAtomValue(appointmentDataAtom);
  const status = useAtomValue(recorderStatusAtom);

  // base case - we've yet to interact with a patient/appointment
  if (!appointmentData) return true;

  // case where we're in a context with no appointment data available
  if (!appointment) return false;

  // case where there is no active recording session
  if (['idle', 'stopped'].includes(status)) return true;

  return (
    appointmentData.estimatedVisitId === appointment.estimatedVisitId &&
    appointmentData.unifiedId === appointment.unifiedId
  );
};
